import { AxiosInstance } from 'axios'
import { MediaObjectList } from '../types'
import { BlocksContent } from '@strapi/blocks-react-renderer'

export interface GetOurClinicArgs {
  locale: string
}

export interface OurClinicDto {
  data: {
    id: number
    attributes: {
      our_clinic_title: string
      our_clinic: {
        id: number
        text: BlocksContent
        main_video: {
          data: {
            id: number
            attributes: {
              url: string
              mime: string
            }
          }
        }
        images?: MediaObjectList
      }
    }
  }
  meta: Record<string, unknown>
}

export const getOurClinic = async (
  client: AxiosInstance,
  { locale }: GetOurClinicArgs,
): Promise<OurClinicDto['data']['attributes']> => {
  const path = `/home-page`
  const params = {
    locale,
    fields: ['our_clinic_title'],
    populate: {
      our_clinic: {
        populate: {
          fields: ['text'],
          main_video: { fields: ['url', 'mime'] },
          images: { populate: '*' },
        },
      },
    },
  }
  return (await client.get<OurClinicDto>(path, { params })).data.data.attributes
}
